<div class="app-content vertical-scroll" cdkScrollable>
    <ssg-stale-dated-checks-info-table></ssg-stale-dated-checks-info-table>
</div>
